module.exports = __webpack_public_path__ + "portal-static/img/8.86a15e4c.jpg";